// ============================================================
// RestrictedClientPanel.tsx — (Audit batch 3, H4) the client page for a
// client behind an ethical wall. The server refused the record (403
// { restricted: true } — backend lib/clientAccess): the viewer can't reach any
// of the client's cases. Nothing about the client is shown — the same
// show-but-lock language as a "Restricted case" card (dashed, lock icon).
// ============================================================
import React, { useEffect, useRef } from 'react'
import { RESTRICTED_CLIENT_TIP } from '../../api/casevoApi'

const RestrictedClientPanel: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  // Focus lands here, so keyboard and screen-reader users hear where they are.
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => { heading.current?.focus() }, [])
  return (
  // (Big-audit batch 4, item 12) In the middle of the content area, both ways.
  <div className="flex-1 min-h-[calc(100vh-180px)] grid place-items-center px-4 py-6" data-centred-panel>
  <section aria-labelledby="restricted-client-h" className="w-full max-w-[560px] rounded-[14px] border border-dashed border-casevo-border bg-casevo-surface px-5 py-6 sm:px-7 sm:py-7 text-casevo-text-soft text-center">
    <span className="w-[42px] h-[42px] mx-auto rounded-[12px] bg-casevo-border-soft grid place-items-center" aria-hidden="true">
      <svg viewBox="0 0 24 24" className="w-[20px] h-[20px]" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
    </span>
    <p className="mt-4 text-xs uppercase tracking-widest text-casevo-brand">Client</p>
    <h1 ref={heading} tabIndex={-1} id="restricted-client-h" className="mt-1 text-xl sm:text-2xl font-medium text-casevo-forest outline-none">Restricted client</h1>
    <p className="mt-2 text-[14px] leading-[1.55]">{RESTRICTED_CLIENT_TIP}</p>
    <p className="mt-1 text-[13px] leading-[1.55]">If you need to work with them, ask the case’s fee earner or an admin to add you to one of their cases.</p>
    <button type="button" onClick={onBack}
      className="mt-5 inline-flex items-center h-10 px-4 rounded-[10px] border border-casevo-border bg-casevo-surface text-[14px] font-medium text-casevo-forest hover:border-casevo-mid focus:outline-none focus-visible:ring-2 focus-visible:ring-casevo-mid">
      Back to clients
    </button>
  </section>
  </div>
  )
}

export default RestrictedClientPanel
